import { apiGetMe } from '../../common/api/profile'
import { apiUnarchiveAssessmentFile } from '../../common/api/assessment'

const fetchArchivedFiles = () => ({
  requestPrefix: 'ARCHIVED_FILES:FETCH',
  request: () =>
    apiGetMe({
      include:
        'account.teacher_type.archived_assessment_files,account.teacher_type.assessment_file.details,account.teacher_type.assessment_file.timestamps,account.teacher_type.assessment_file.student_types,account.teacher_type.assessment_file.student_type.account,account.teacher_type.assessment_file.student_type.account.names,account.teacher_type.assessment_file.contributions,account.teacher_type.assessment_file.contributors,account.teacher_type.assessment_file.contributor,account.teacher_type.assessment_file.account.names,account.teacher_type.assessment_file.account.avatar,account.teacher_type.assessment_file.works,account.teacher_type.assessment_file.work.media,account.teacher_type.assessment_file.work.medium.thumb,account.teacher_type.assessment_file.student_type.year_group,account.teacher_type.assessment_file.student_type.year_group.names,account.teacher_type.assessment_file.student_type.year_group.order'
    })
})

const unarchiveArchivedFile = id => ({
  requestPrefix: 'ARCHIVED_FILES:UNARCHIVE',
  params: { id },
  request: () => apiUnarchiveAssessmentFile(id)
})

export { fetchArchivedFiles, unarchiveArchivedFile }
